var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [_vm._v("Rol")]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.role_id ? "is-invalid" : "",
            attrs: {
              items: _vm.roles,
              "item-text": "name",
              "item-value": "id",
              "hide-details": "",
            },
            model: {
              value: _vm.data.role_id,
              callback: function ($$v) {
                _vm.$set(_vm.data, "role_id", $$v)
              },
              expression: "data.role_id",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.role_id, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c("div", { staticClass: "form-group mb-2" }, [
        _c("small", { staticClass: "input-title" }, [_vm._v("Descuento: ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-group input-group-sm" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.discount,
                  expression: "data.discount",
                },
              ],
              staticClass: "form-control form-control-sm",
              class: _vm.errors.discount ? "is-invalid" : "",
              attrs: { type: "text", placeholder: "0.00" },
              domProps: { value: _vm.data.discount },
              on: {
                keypress: _vm.DOUBLE,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.data, "discount", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.errors.discount, function (error, index) {
              return _c(
                "small",
                { key: index, staticClass: "invalid-feedback" },
                [_vm._v(_vm._s(error))]
              )
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Subscripción al boletín, noticias, ofertas, ..."),
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.subscribed ? "is-invalid" : "",
            attrs: { items: _vm.options, "hide-details": "" },
            model: {
              value: _vm.data.subscribed,
              callback: function ($$v) {
                _vm.$set(_vm.data, "subscribed", $$v)
              },
              expression: "data.subscribed",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.subscribed, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Cuenta Completa"),
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.complete ? "is-invalid" : "",
            attrs: { items: _vm.options, "hide-details": "" },
            model: {
              value: _vm.data.complete,
              callback: function ($$v) {
                _vm.$set(_vm.data, "complete", $$v)
              },
              expression: "data.complete",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.complete, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Permitir Crédito"),
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.credit ? "is-invalid" : "",
            attrs: { items: _vm.options, "hide-details": "" },
            model: {
              value: _vm.data.credit,
              callback: function ($$v) {
                _vm.$set(_vm.data, "credit", $$v)
              },
              expression: "data.credit",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.credit, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [_vm._v("Pin: ")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.pin,
                expression: "data.pin",
              },
            ],
            staticClass: "form-control form-control-sm",
            class: _vm.errors.pin ? "is-invalid" : "",
            attrs: { type: "text", placeholder: "0000" },
            domProps: { value: _vm.data.pin },
            on: {
              keypress: _vm.NUMBER,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "pin", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.pin, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Última fecha de exoneración: "),
          ]),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: {
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": "",
                "min-width": "auto",
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function (ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "v-text-field",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "form-control form-control-sm",
                              class: _vm.errors.last_exemption_at
                                ? "is-invalid"
                                : "",
                              attrs: {
                                value: _vm.data.last_exemption_at,
                                "hide-details": "",
                                readonly: "",
                                clearable: "",
                                placeholder: "0000-00-00",
                              },
                              on: {
                                "click:clear": function ($event) {
                                  _vm.data.last_exemption_at = ""
                                },
                              },
                            },
                            "v-text-field",
                            attrs,
                            false
                          ),
                          on
                        )
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.menu_last_exemption,
                callback: function ($$v) {
                  _vm.menu_last_exemption = $$v
                },
                expression: "menu_last_exemption",
              },
            },
            [
              _vm._v(" "),
              _c("v-date-picker", {
                attrs: { "no-title": "", scrollable: "" },
                on: {
                  input: function ($event) {
                    _vm.menu_last_exemption = false
                  },
                },
                model: {
                  value: _vm.data.last_exemption_at,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "last_exemption_at", $$v)
                  },
                  expression: "data.last_exemption_at",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.errors.last_exemption_at, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Precio por libra: "),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.price_per_pound,
                expression: "data.price_per_pound",
              },
            ],
            staticClass: "form-control form-control-sm",
            class: _vm.errors.price_per_pound ? "is-invalid" : "",
            attrs: { type: "text", placeholder: "0" },
            domProps: { value: _vm.data.price_per_pound },
            on: {
              keypress: _vm.DOUBLE,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "price_per_pound", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.price_per_pound, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.data.price_per_pound > 0
      ? _c("div", { staticClass: "col-lg-6" }, [
          _c(
            "div",
            { staticClass: "form-group mb-2" },
            [
              _c("small", { staticClass: "input-title" }, [
                _vm._v("Monto minimo facturable: "),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.minimum_billable_amount,
                    expression: "data.minimum_billable_amount",
                  },
                ],
                staticClass: "form-control form-control-sm",
                class: _vm.errors.minimum_billable_amount ? "is-invalid" : "",
                attrs: { type: "text", placeholder: "0" },
                domProps: { value: _vm.data.minimum_billable_amount },
                on: {
                  keypress: _vm.DOUBLE,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.data,
                      "minimum_billable_amount",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(
                _vm.errors.minimum_billable_amount,
                function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }
              ),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v("\n                        %\n                    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }